import {forEach} from "lodash";
import {game} from "../GameCore";
import {createGround, updateGround, resetGround} from "./ground/Ground";
import {gameState} from "../config/GameState";
import {resetPlatforms, updatePlatforms, createPlatformSprites, updateLights, allowPlatforms} from "./platforms/Platforms";
import {createPowerUps, resetPowerUps} from "./power-ups/PowerUps";
import {createBackground, resetBackground} from './backgrounds/Backgrounds';
import {resetStage} from './stages/StageManager';
import {createObstacles, resetObstacles} from './ground/Obstacles';
import {hideSignInstantly} from '../sprites/player/Player';

//export var levelGroup: Phaser.Group;
export var levelGroup: Phaser.Sprite;
export var levelSprites: Phaser.Sprite[];


/**
 * reset the level group
 */
export function resetLevelGroup()
{
    levelGroup.reset(0,0);
}


/**
 * create the level container and elements
 */
export function createLevel()
{
    //  add a group to contain the level

    levelGroup = game.add.sprite(0, 0);

    //  enable physics on the sprite

    game.physics.arcade.enable(levelGroup);

    levelGroup.body.immovable = true;
    levelGroup.body.allowGravity = false;
    levelGroup.body.collideWorldBounds = false;

    //  reset the current stage

    resetStage();

    //  add background tiles

    createBackground();

    //  add tiles to the floor

    createGround();

    //  create platform sprites

    createPlatformSprites();

    //  create power-ups

    createPowerUps();

    //  create obstacles

    createObstacles();
}


/**
 * update the level
 */
export function updateLevel()
{
    //  update floor tiles

    updateGround();

    //  move the level group on by the player's current speed

    levelGroup.body.velocity.x = -gameState.player.speed * 50 * gameState.player.multiplier * gameState.player.powerupMultiplier;

    //  update platforms

    updatePlatforms();
    updateLights();
}


/**
 * reset the current state of the level
 */
export function resetLevel()
{
    //  reset level

    resetLevelGroup();

    resetStage();
    resetBackground();
    resetGround();
    resetPlatforms();

    //  lay the ground for the game

    createGround();

    //  reenable platforms

    allowPlatforms(true);

    //  reset power ups

    resetPowerUps();
    resetObstacles();

    hideSignInstantly();
}



// WEBPACK FOOTER //
// ./src/ts/game/level/Level.ts